import { useAtomValue } from "jotai";
import dynamic from "next/dynamic";
import { NOT_AVAILABLE_TEXT } from "../../constants";
import { baseAtom } from "../../stores/jotai/base";
import { isServerSide } from "../../util";

const ProductFruits = dynamic(
    () => import("react-product-fruits").then((mod) => mod.ProductFruits),
    { ssr: false }
);

const ProductFruitsWrapper = () => {
    const base = useAtomValue(baseAtom);
    const { user } = base;
    const [firstname, lastname] = user?.name?.split(" ") || [
        NOT_AVAILABLE_TEXT,
        NOT_AVAILABLE_TEXT,
    ];
    const productFruitsUser = {
        username: user?.username || NOT_AVAILABLE_TEXT,
        firstname,
        lastname,
        email: user?.email || NOT_AVAILABLE_TEXT,
    };

    return !isServerSide() ? (
        <ProductFruits
            workspaceCode={process.env.NEXT_PUBLIC_PF_WORKSPACE_CODE}
            language="en"
            user={productFruitsUser}
        />
    ) : null;
};

export default ProductFruitsWrapper;
